import React, { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';

import { openModalPage } from 'actions/modalPage';
import { modalPages } from 'constants/modalPage';

interface Props {
  title: string;
  beforeSelect?: () => void;
  children: ReactNode;
}

function GridModalTrigger({ title, beforeSelect, children }: Props) {
  const dispatch = useDispatch();

  function openGrid() {
    dispatch(
      openModalPage({
        component: modalPages.GridModal,
        groupID: modalPages.GridModal,
        props: { title, beforeSelect },
      }),
    );
  }

  if (React.isValidElement(children)) {
    return React.cloneElement(children, {
      onClick: event => {
        children.props.onClick?.(event);
        openGrid();
      },
    });
  }

  return <Button onClick={openGrid}>Open</Button>;
}

export default GridModalTrigger;
